import { SxProps } from '@mui/system';
import { OverflowForDesktop } from '10.quickConnect.app/components/shared/LayOut/TopBar/style';

export const MainBox: SxProps = {
  width: '100%',
  height: { md: '80vh', lg: '80vh' },
  marginBottom: { xs: '80px', sm: '80px' },
  overflowY: OverflowForDesktop,
};
